<!--

Displayed at the top of department pages. Features the name of the department,
phone, address, hours and email. A simpler version that only includes department, 
phone and email exists also under the name "PageHeading".

Example (default) usage:

<page-heading-info
title="Jefferson County Treasurer"
email="treasurer@jeffersoncountyoh.com"
phone="(740) 283-8583"
courthouse="true"
1st Floor, Room 100
></page-heading-info>


If you need a page heading with an address that isn't at the courthouse, use the 
AddressSimple component to inject a custom address: 

<page-heading-info
title="Jefferson County Juvenile Court"
email="juvenile@jeffersoncountyoh.com"
phone="(740) 283-8557"
>
  <address-simple
  line1="16001 State Route 7"
  line2="PO Box 549"
  line3="Steubenville, OH 43952"
  ></address-simple>

</page-heading-info>

-->

<template>
  <div class="row">
    <div class="col mt-4">

      <div class="row justify-content-between text-primary">
        <div class="col-lg-7 mt-4">
          <div class="title">
          {{title}}
          </div>

          <div class="phone" v-if="phone">
            <template>
              <i class="material-icons">call</i>
              {{phone}}
            </template>
          </div>

          <div class="phone2" v-if="phone2">
            <template>
              <i class="material-icons">call</i>
              {{phone2}}
            </template>
          </div>

          <div class="fax" v-if="fax">
            <template>
              <i class="material-icons">print</i>
              {{fax}}
            </template>
          </div>

          <div class="email" v-if="email">
            <template>
              <div class="row">
                <div class="col mt-1">
                  <i class="material-icons align-self-bottom">email</i>&nbsp;
                  <a :href="`mailto:${this.email}`">{{email}}</a>
                </div>
              </div>
            </template>
          </div>

        </div>

        <!-- info area -->
        
        <div class="col-lg-4 mt-4 margin-left-1">
          <div v-if="courthouse">
            <address-simple
            line1="Jefferson County Courthouse"
            line2="301 Market Street"
            :line3="pobox"
            line4="Steubenville, OH 43952"
            :line5="floor"
            >
            </address-simple>
          </div>

          <div v-else>
            <slot></slot>
          </div>

          <div v-if="hours" class="row mt-3">
            <div class="col-1-xs icon-width">
              <i class="material-icons">schedule</i>
            </div>

            <div class="col-11-xs">
              <div>{{hours}}</div>
              <div>{{lunch}}</div>
            </div>
          </div>

        </div>
        
      </div>

      <div class="row liner">
        <div class="col">
          <hr />  
        </div>
      </div>

   </div>
  </div>
</template>

<script>

import AddressSimple from '@/components/layout/AddressSimple.vue'

export default {
  components: {
    AddressSimple
  },
  data () {
    return {
      formattedEmail: ""
    }
  },
  props: ['title','phone','phone2','email',"hours","lunch","hoursDays","weekend","pobox","floor","fax","courthouse"],
  created: function () {

  }
}
</script>

<style scoped>

.liner hr {
  margin-top: 2.0em;
  margin-bottom: 0;
  border-top: 3px solid #bfb093;
}

.title {
  font-size: 2.0em;
  font-weight: bold;
  margin: 0;
  padding: 0;
  line-height: 1.25em;
}

.phone {
  font-size: 1.25em;
  margin: 1.0em 0 0 0;
}

.phone2 {
  font-size: 1.25em;
  margin: 0.75em 0 0 0;
}

.fax {
  font-size: 1.25em;
  margin: 0.25em 0 1.25em 0;
}

.email {
  margin: 0.25em 0 0 0;
  font-weight: bold;
}

.icon-width {
  max-width: 16px;
  margin-right: 10px;
}

</style>
